module.exports = __webpack_public_path__ + "images/emoji/yen.5c40eb8b614fa53bd814.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/yen.png
// module id = 29lF
// module chunks = 24